import React from 'react';
import { Currency } from '@common/components';
import { toUSFormat } from 'works/legacy/lib/date-helper';
import {
  useExtensionOffersDeviation,
  useRateCardCreationAttributes,
} from './_rates-long-term-context';
import {
  DeprecatedStatusPill,
  TextCapitalized,
} from '@institutions/components';
import { RatesLongTermUpdatesDeviationTable } from './_rates-long-term-step-updates-deviation-table';
import { BillingCardExtensionOfferType } from '@institutions/graphql';
import { getRateByEmploymentType } from '@institutions/services';

export function RatesLongTermStepUpdatesTabExtensionOffer({
  dataSource,
}: {
  dataSource?: BillingCardExtensionOfferType[];
}) {
  const [rateCardAttributes] = useRateCardCreationAttributes();

  const [extensionOffers, { setAll, deviate, undeviate }] =
    useExtensionOffersDeviation();
  const tableColumns = [
    {
      dataIndex: ['staffingRequestAssignment', 'staffingRequest', 'code'],
      key: 'id',
      title: 'Id',
    },
    {
      dataIndex: ['staffingRequestAssignment', 'worksProfile', 'fullName'],
      key: 'teamMember',
      title: 'Team Member',
    },
    {
      dataIndex: ['staffingRequestAssignment', 'supplier', 'name'],
      key: 'supplier',
      title: 'Supplier',
    },
    {
      dataIndex: ['staffingRequestAssignment', 'organizationBusiness', 'name'],
      key: 'facility',
      title: 'Facility',
    },
    {
      dataIndex: 'shiftType',
      key: 'shiftType',
      title: 'Shift Type',
      render: (shiftType: string) => <TextCapitalized text={shiftType} />,
    },
    {
      dataIndex: 'startDate',
      key: 'startDate',
      title: 'Start Date',
      render: toUSFormat,
    },
    {
      dataIndex: 'endDate',
      key: 'endDate',
      title: 'End Date',
      render: toUSFormat,
    },
    {
      dataIndex: 'billingRegularRate',
      key: 'currentRate',
      title: 'Current Rate',
      render: (value: number) => <Currency value={value} />,
    },
    {
      dataIndex: 'extensionOffer',
      key: 'newRate',
      title: 'New Rate',
      render: (_: unknown, record: BillingCardExtensionOfferType) => {
        const billingCardRate = getRateByEmploymentType(
          rateCardAttributes,
          record.shiftType,
          record.staffingRequestAssignment.employmentType
        );

        return <Currency value={billingCardRate || 0} />;
      },
    },
    {
      dataIndex: 'state',
      key: 'status',
      title: 'Status',
      render: (value: string) => <DeprecatedStatusPill status={value} />,
    },
  ];

  return (
    <RatesLongTermUpdatesDeviationTable
      dataSource={dataSource}
      columns={tableColumns}
      onDeviateList={setAll}
      onDeviateItem={deviate}
      onUndeviateItem={undeviate}
      deviatedIds={extensionOffers}
    />
  );
}
